import { get } from "../methods";
function getLearningLoop(contentKey) {
  return get({
    url: `api/learning-loop/${contentKey}`
  });
}
export {
  getLearningLoop
};
